<template>
  <div class="mx-xl-4 mx-lg-2 mx-md-2 pb-5">
    <div class="d-flex flex-column">
      <div v-if="aide.lienYoutube" class="mb-3">
        <div class="content-inner youtube-container embed-responsive embed-responsive-16by9">
          <iframe
            :data-src="aide.lienYoutube"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>

          <!-- Message & "I accept" button -->

          <div class="video-consent-overlay">
            <div class="scrollable-section">
              <div class="logo">
                <svg-icon icon-name="youtube"></svg-icon>
              </div>
              <div class="video-consent-overlay-text">
                <p>
                  {{ $t('youtubeVideoConsent.texte') }}
                </p>
              </div>
            </div>
            <button class="video-consent-overlay-accept-button">
              {{ $t('youtubeVideoConsent.texteBoutonAccept') }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div v-for="(questionRep, index) in aide.listeQuestionsReponses" :key="questionRep['id']">
          <div class="d-flex flex-column">
            <ZoneEscamotable :content="getContentZoneEscamotable(questionRep)" />
            <Separateur v-if="index != listeQuestionsReponses.length - 1" class="w-100 mt-1" />
          </div>
        </div>
        <div>
          <!-- Empêcher que l'appel REST se fasse quand l'aide est fermée -->
          <Heritage v-if="aide.isAideActif" :content="contentHeritage" />
          <!-- TODO: corriger problème accessibilité: https://css-tricks.com/accessible-svg-icons/ -->
          <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
          <!-- a v-bind="bindUrlNousJoindre" class="btnVide py-1">
            <svg-icon class="iconTaille mr-2 color-filling" icon-name="ic-tel"></svg-icon>
            <label class="sr-only">{{ $t("contact") }}</label>
          </a-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { handleYoutubeConsent } from '@/helpers/ConsentHelpers';

import Heritage from '@/components/base/Heritage';
import Separateur from '@/components/base/Separateur';
import ZoneEscamotable from '@/components/base/ZoneEscamotable';
import SvgIcon from '../helpers/SvgIcon.vue';

export default {
  name: 'AideContenu',
  components: {
    Heritage,
    Separateur,
    ZoneEscamotable,
    SvgIcon,
  },
  props: ['idRubriqueAide'],
  data() {
    return {
      contentHeritage: { lienInterne: process.env.VUE_APP_JEL_NOEUD_AIDECONTENU },
      listeQuestionsReponses: [],
    };
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          href: '/fr/pour-nous-joindre',
          hrefMock: 'https://www.espacejeux.com/fr/pour-nous-joindre',
          hrefMobile: '/fr/pour-nous-joindre',
        },
      },
      en: {
        messageComponent: {
          href: '/en/contact-us',
          hrefMock: 'https://www.espacejeux.com/en/contact-us',
          hrefMobile: '/en/contact-us',
        },
      },
    },
  },
  computed: {
    ...mapState(['aide']),
    bindUrlNousJoindre() {
      let href = '';
      if (this.$isMobile()) {
        href = this.$t('messageComponent.hrefMobile');
      } else if (process.env.VUE_APP_IS_MOCK == 'true') {
        href = this.$t('messageComponent.hrefMock');
      } else {
        href = this.$t('messageComponent.href');
      }
      return {
        href,
        target: this.$isMobile() ? '' : '_blank',
      };
    },
  },
  mounted() {
    handleYoutubeConsent();
  },
  methods: {
    getContentZoneEscamotable(questionRep) {
      return {
        titre: questionRep.question,
        texte: this.normaliserResponseTexte(questionRep.reponse),
        isOuvert: this.isActif(questionRep.id) || questionRep.isOuvert,
        name: questionRep.name,
        isAide: true,
        typeTitre: 'sousTitre',
      };
    },
    isNouvelleRubriqueAideId() {
      let reponseIsNouvelle = true;

      if (this.aide.rubriqueAidePrecedente.id) {
        if (this.idRubriqueAide.length == this.aide.rubriqueAidePrecedente.id.length) {
          reponseIsNouvelle = this.isOrdreChange();
        }
      }
      return reponseIsNouvelle;
    },
    isOrdreChange() {
      return this.idRubriqueAide.join(',') !== this.aide.rubriqueAidePrecedente.id.join(',');
    },
    isActif(idQuestion) {
      return idQuestion != undefined && this.idQuestion == idQuestion;
    },
    setQuestionsOuvertes() {
      let ids = this.idQuestion;
      if (ids !== 0 && ids !== null) {
        if (this.idQuestion.includes('|')) {
          ids = ids.split(/\|/);
        }
        this.listeQuestionsReponses = this.listeQuestionsReponses.map((element) => {
          if (ids.includes(element.id)) {
            return { ...element, isOuvert: true };
          }
          return { ...element };
        });
      }
    },
    normaliserResponseTexte(texte) {
      const pattern = /[\\/]?magnoliaAuthor/;
      const texteModifie = texte.replace(
        new RegExp(pattern, 'g'),
        process.env.VUE_APP_SITE_BASENAME
      );
      return texteModifie;
    },
  },
};
</script>

<style lang="scss">
ul {
  padding: 0;
  padding-left: 1em;
  list-style: disc;
  list-style-position: outside;

  li {
    text-align: left;
  }
}

a .color-filling {
  fill: $couleur-primaire;
}

a:hover .color-filling {
  fill: $couleur-texte-primaire-focus;
}

button .color-filling {
  fill: $couleur-primaire;
}

button:hover .color-filling {
  fill: $couleur-texte-primaire-focus;
}
</style>
